import { useNavigate } from 'react-router-dom';
import { ArrowBack, DarkMode, LightMode } from '@mui/icons-material';
import { useThemePreference } from '@practium/features/theme';
import styles from './ThemeDesignPage.module.css';

export const ThemeDesignPage = () => {
	const navigate = useNavigate();
	const { theme, mode, changeTheme, changeMode, availableThemes, isThemePreferenceBusy } =
		useThemePreference();

	return (
		<div className={styles.page}>
			<button
				className={styles.backButton}
				type="button"
				onClick={() => navigate('/configuracoes')}
			>
				<ArrowBack fontSize="small" /> Voltar para configurações
			</button>
			<header className={styles.header}>
				<p className={styles.eyebrow}>Identidade visual</p>
				<h1>Cores & Design do Practium</h1>
				<p>Escolha a paleta e o modo de exibição usados pelo painel administrativo.</p>
			</header>
			<section className={styles.section}>
				<div className={styles.sectionHeading}>
					<div>
						<h2>Paleta de cores</h2>
						<p>A alteração é aplicada imediatamente e salva na sua conta.</p>
					</div>
				</div>
				<div className={styles.themeGrid}>
					{availableThemes.map((item) => (
						<button
							key={item.id}
							type="button"
							className={`${styles.themeOption} ${theme === item.id ? styles.selected : ''}`}
							onClick={() => changeTheme(item.id)}
							disabled={isThemePreferenceBusy}
						>
							<span className={styles.swatch} style={{ backgroundColor: item.color }} />
							<span>{item.name}</span>
							{theme === item.id && <strong>Ativo</strong>}
						</button>
					))}
				</div>
			</section>
			<section className={styles.section}>
				<div className={styles.sectionHeading}>
					<div>
						<h2>Modo de exibição</h2>
						<p>Defina como o sistema deve apresentar os elementos da interface.</p>
					</div>
				</div>
				<div className={styles.modeGrid}>
					<button
						className={`${styles.modeOption} ${mode === 'light' ? styles.selected : ''}`}
						type="button"
						onClick={() => changeMode('light')}
						disabled={isThemePreferenceBusy}
					>
						<LightMode /> <span>Claro</span>
					</button>
					<button
						className={`${styles.modeOption} ${mode === 'dark' ? styles.selected : ''}`}
						type="button"
						onClick={() => changeMode('dark')}
						disabled={isThemePreferenceBusy}
					>
						<DarkMode /> <span>Escuro</span>
					</button>
				</div>
			</section>
		</div>
	);
};
